import { CloseRounded, Search } from '@mui/icons-material';
import { Box, Divider, FormControl, IconButton, OutlinedInput, Typography, useTheme } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';

interface ICustomSearchInputProps {
  label?: string;
  placeholder: string;
  setActivePage: () => void;
  nameSearch: string;
  setNameSearch: (nameSearch: string) => void;
  ariaLabel?: string;
}

export const NewCustomSearchInput: React.FC<ICustomSearchInputProps> = ({ placeholder, setActivePage, nameSearch, setNameSearch, label, ariaLabel }) => {
  const theme = useTheme();
  const [inputWidth, setInputWidth] = useState<string>('160px');

  useEffect(() => {
    const placeholderLength = placeholder.length;
    const calculatedWidth = placeholderLength > 15 && `${placeholderLength * 8.7}px`;

    setInputWidth(calculatedWidth);
  }, [placeholder]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameSearch(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setActivePage();
    }
  };

  const handleClearSearch = () => {
    setNameSearch('');
    setActivePage();
  };

  return (
    <Fragment key={label}>
      <Box
        sx={{
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
          [theme.breakpoints.up('sm')]: {
            maxWidth: '250px',
          },
        }}
      >
        <FormControl fullWidth>
          <Typography textAlign="left" color="text.primary" fontWeight="600" fontSize="16px">
            {label}
          </Typography>
          <OutlinedInput
            id={`${placeholder}-search-input`}
            placeholder={placeholder}
            value={nameSearch}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
            sx={{
              minWidth: inputWidth,
              height: '43px',
              borderRadius: '8px',
              fontSize: '.875rem',
              '& .MuiOutlinedInput-input': {
                padding: '14px 6px 14px 9.5px',
              },
              '& fieldset': {
                top: '0',
                borderColor: '#808080!important',
                color: '#808080',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#808080',
              },
              '& .MuiOutlinedInput-input::placeholder': {
                color: '#808080',
                opacity: 1,
              },
            }}
            endAdornment={
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 0.5 }} gap={0.5}>
                <IconButton onClick={setActivePage} edge={nameSearch ? 'start' : 'end'}>
                  <Search
                    fontSize="small"
                    color={nameSearch ? 'secondary' : 'inherit'}
                    sx={{
                      color: nameSearch ? 'secondary' : '#808080',
                    }}
                  />
                </IconButton>
                {nameSearch && (
                  <>
                    <Divider orientation="vertical" flexItem />
                    <IconButton onClick={handleClearSearch} edge="end">
                      <CloseRounded fontSize="small" color={'error'} />
                    </IconButton>
                  </>
                )}
              </Box>
            }
          />
        </FormControl>
      </Box>
    </Fragment>
  );
};
